/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Act_FreeInputs */

const en_of_landing_act_free = /** @type {(inputs: Of_Landing_Act_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See who's free`)
};

const id_of_landing_act_free = /** @type {(inputs: Of_Landing_Act_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat siapa yang luang`)
};

/**
* | output |
* | --- |
* | "See who's free" |
*
* @param {Of_Landing_Act_FreeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_act_free = /** @type {((inputs?: Of_Landing_Act_FreeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Act_FreeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_act_free(inputs)
	return en_of_landing_act_free(inputs)
});